import React, { useRef } from "react";
import PropTypes from "prop-types";
import styled, { css } from "styled-components";

import breakpoints from "_constants/breakpoints";

import Pagination from "components/Pagination/Pagination";

const Container = styled.div`
  min-width: 100%;
  max-width: 100%;

  @media (max-width: ${breakpoints.mobileL}) {
    padding: 0;
  }
`;
const Title = styled.h1`
  font-weight: bold;
  font-size: 16px;
  color: #7b848d;

  @media (max-width: ${breakpoints.mobileL}) {
    padding: 0;
  }
`;
const Body = styled.div``;
const ClassificationContainer = styled.div`
  width: 100%;
`;
const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: left;
  align-items: center;
  min-height: 24px;
  min-width: 100%;
  padding: 16px 0;

  &:nth-child(2n + 1) {
    background-color: #fafaff;
  }

  ${({ right }) =>
    right &&
    css`
      justify-content: right;
    `}

  @media (max-width: ${breakpoints.tablet}) {
    flex-direction: column;
  }

  @media (max-width: ${breakpoints.mobileL}) {
    justify-content: center;
    align-items: center;
  }
`;
const Cell = styled.div`
  width: 50%;
  text-align: left;
  font-style: normal;
  font-weight: bold;
  font-size: 12px;
  color: #7b848d;

  @media (max-width: ${breakpoints.tablet}) {
    width: 100%;
    padding: 0;
  }
`;
const DateCell = styled(Cell)`
  text-transform: uppercase;
`;
const Label = styled(Cell)`
  font-weight: 400;
  max-width: 50%;
  padding-right: 20px;

  @media (max-width: ${breakpoints.tablet}) {
    max-width: 100%;
    padding: 0;
    min-width: 80px;
    padding-rignt: 0;
  }
`;

function TableRow({ index, ...props }) {
  return (
    <ClassificationContainer index={index}>
      <Row>
        <Label>INTERNETIONAL CODE</Label>
        <Cell>{props.internationalCode.join(", ")}</Cell>
      </Row>
      <Row>
        <Label>US CODE</Label>
        <Cell>{props.usCode.join(", ")}</Cell>
      </Row>
      <Row>
        <Label>STATUS CODE</Label>
        <Cell>{props.statusCode}</Cell>
      </Row>
      <Row>
        <Label>STATUS DATE</Label>
        <DateCell>{props.statusDate}</DateCell>
      </Row>
      <Row>
        <Label>FIRST USE ANYWHERE DATE</Label>
        <DateCell>{props.firstUseAnywhereDate}</DateCell>
      </Row>
      <Row>
        <Label>FIRST USE IN COMMERCE DATE</Label>
        <DateCell>{props.firstUseInCommerceDate}</DateCell>
      </Row>
      <Row>
        <Label>PRIMARY CODE</Label>
        <Cell>{props.primaryCode}</Cell>
      </Row>
    </ClassificationContainer>
  );
}

TableRow.propTypes = {
  index: PropTypes.number,
  internationalCode: PropTypes.arrayOf(PropTypes.string),
  usCode: PropTypes.arrayOf(PropTypes.string),
  statusCode: PropTypes.string,
  statusDate: PropTypes.string,
  firstUseAnywhereDate: PropTypes.string,
  firstUseInCommerceDate: PropTypes.string,
  primaryCode: PropTypes.string,
};

function ClassificationListMobile({ classifications, currentPage, changePage }) {
  const contentRef = useRef(null);

  if (!classifications && !Array.isArray(classifications)) return null;

  const result = classifications[currentPage - 1];

  const handleChangePage = (page) => {
    if (page !== currentPage) {
      changePage(page);
      contentRef.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <Container>
      {classifications.length ? (
        <>
          <Title ref={contentRef}>Classifications</Title>

          <Body>
            <Pagination
              bottom
              currentPage={currentPage}
              totalPages={classifications.length}
              onClick={handleChangePage}
            />
            <TableRow {...result} />
          </Body>
        </>
      ) : (
        <Title>No Classifications</Title>
      )}
    </Container>
  );
}

ClassificationListMobile.propTypes = {
  classifications: PropTypes.arrayOf(PropTypes.object),
  currentPage: PropTypes.number,
  changePage: PropTypes.func,
};

export default ClassificationListMobile;
